import { handleHourMismatch } from "../NewPushNotification/utils";

export const calcTimeDifference = (dueOn: string) => {
  const now = new Date().getTime();
  const scheduledTime = new Date(handleHourMismatch(dueOn)).getTime();
  return (scheduledTime - now) / 1000;
};

export const isDuePastOrWithinHour = (dueOn: string) => {
  const diff = calcTimeDifference(dueOn);
  return diff < 0 || (diff > 0 && diff < 3600);
};
